'use client';
import type { Idea } from '@/lib/research/state-machine';

interface Props { closed: Idea[] }

export function TrackRecord({ closed }: Props) {
  if (closed.length === 0) {
    return (
      <div className="text-[12px] text-[#64748b]">
        No closed ideas yet. The desk&apos;s track record builds here as positions resolve.
      </div>
    );
  }
  return (
    <table className="w-full text-[12px] border-collapse">
      <thead>
        <tr className="text-[10px] text-[#64748b] uppercase tracking-wide border-b border-[#1e293b]">
          <th className="text-left py-2 pl-3 pr-2">Symbol</th>
          <th className="text-left py-2 px-2">Type</th>
          <th className="text-left py-2 px-2">Outcome</th>
          <th className="text-right py-2 px-2">Days held</th>
          <th className="text-right py-2 px-2 pr-3">Closed</th>
        </tr>
      </thead>
      <tbody>
        {closed.map((idea, i) => {
          const paid = idea.status === 'closed-paid-off';
          return (
            // Composite key includes initiationDate to disambiguate two ideas on
            // the same symbol that close on the same day (e.g. JLL today: one
            // closed-paid-off + one immediate re-initiation that also closed).
            // Index fallback guards against the unlikely event where two ideas
            // share symbol+open+close dates.
            <tr key={`${idea.symbol}-${idea.initiationDate}-${idea.closedDate}-${i}`} className="border-b border-[#1e293b]">
              <td className="py-2 pl-3 pr-2 font-mono font-semibold text-white">{idea.symbol}</td>
              <td className="py-2 px-2 text-[#94a3b8]">
                {idea.type === 'swap' ? `swap from ${idea.swapSource}` : 'add'}
              </td>
              <td className="py-2 px-2">
                <span className={`px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide ${
                  paid ? 'bg-emerald-600/20 text-emerald-300' : 'bg-red-600/20 text-red-300'
                }`}>
                  {paid ? 'Paid off' : 'Violated'}
                </span>
              </td>
              <td className="py-2 px-2 text-right tabular-nums text-[#94a3b8]">{idea.daysHeld ?? '—'}</td>
              <td className="py-2 px-2 pr-3 text-right tabular-nums text-[#64748b]">{idea.closedDate}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
